import { render, staticRenderFns } from "./ServicesIntroduction.vue?vue&type=template&id=74c64ea3&scoped=true"
import script from "./ServicesIntroduction.vue?vue&type=script&lang=js"
export * from "./ServicesIntroduction.vue?vue&type=script&lang=js"
import style0 from "./ServicesIntroduction.vue?vue&type=style&index=0&id=74c64ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c64ea3",
  null
  
)

export default component.exports